module.exports = __webpack_public_path__ + "static/media/card_icon_2.95dc1954.png";